import React, { useEffect, useContext, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../../Contexts/AuthContext';

export default function AuthCallback() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setUser } = useContext(AuthContext);
    const hasHandled = useRef(false);

    useEffect(() => {
        if (hasHandled.current) return;
        hasHandled.current = true;
        const token = searchParams.get('token');
        const userJson = searchParams.get('user');
        const error = searchParams.get('error');

        if (error) {
            navigate('/?error=' + error);
            return;
        }

        if (token && userJson) {
            try {
                const user = JSON.parse(decodeURIComponent(userJson));

                localStorage.setItem('token', token);

                setUser(user);
                if (user.is_new) {
                    navigate('/admin?welcome=true');
                } else {
                    if (user.role === 'admin') {
                        navigate('/admin');
                    } else if (user.role === 'eleveur') {
                        navigate('/eleveur');
                    } else {
                        navigate('/');
                    }
                }
            } catch (err) {
                console.error('Failed to parse user data:', err);
                navigate('/?error=invalid_data');
            }
        } else {
            navigate('/?error=missing_credentials');
        }
    }, []);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
            <div style={{
                background: 'white',
                padding: '2rem 3rem',
                borderRadius: '1rem',
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                textAlign: 'center'
            }}>
                <div style={{
                    width: '50px',
                    height: '50px',
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #667eea',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 1rem'
                }}></div>
                <p style={{ color: '#4a5568', fontSize: '1.1rem' }}>
                    Connexion en cours...
                </p>
            </div>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
}